  <section class="impact-exchange-section position-relative overflow-hidden py-5">
    <div class="container py-5">
      <div class="row align-items-center g-5">

        <!-- LEFT COPY -->
        <div class="col-12 col-lg-6">
          <div class="d-flex align-items-center gap-3 text-uppercase text-xs fw-semibold impact-kicker mb-3">
            <span class="impact-kicker-line"></span>
            <span>{{ exchange_data.kicker }}</span>
          </div>

          <h2 class="impact-title mb-3">
            {{ exchange_data.title }}
          </h2>

          <p class="impact-lead mb-0">
            {{ exchange_data.description }}
          </p>
        </div>

        <!-- RIGHT CARD -->
        <div class="col-12 col-lg-6 d-flex justify-content-lg-end">
          <div class="impact-card w-100">
            <!-- Card header -->
            <div class="impact-card-header px-4 pt-4 pb-3">
              <div class="d-flex align-items-center gap-2 text-uppercase text-xs fw-semibold impact-card-kicker">
                <span class="impact-diamond"></span>
                <span>{{ calculator_data.kicker }}</span>
              </div>
              <div class="impact-card-divider mt-3"></div>
            </div>

            <!-- Card body -->
            <div class="px-4 pb-4">
              <div class="text-uppercase text-xs impact-muted mb-2">
                {{ calculator_data.amount_label }}
              </div>

              <div class="impact-amount mb-4">
                {{ calculator_data.amount_value }}
              </div>

              <div class="d-flex flex-column gap-3">
                <div
                  v-for="row in calculator_rows"
                  :key="row.key"
                  class="impact-row d-flex align-items-center justify-content-between px-4 py-3"
                >
                  <div class="impact-row-label text-xs">
                    {{ row.label }}
                  </div>
                  <div class="impact-row-value">
                    {{ row.value }}
                  </div>
                </div>
              </div>

              <div class="impact-card-divider my-4"></div>

              <div class="text-center impact-footnote text-xs">
                {{ calculator_data.footnote }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
